import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactPlaceListComponent } from './contact-place-list.component';
import { ContactPlaceComponent } from './contact-place/contact-place.component';
import { CtModelModule, CtButtonModule } from '@ctsolution/ct-framework';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';

/**
 * Modulo per ContactPlaceListComponent e ContactPlaceComponent
 */
@NgModule({
  declarations: [
    ContactPlaceListComponent,
    ContactPlaceComponent
  ],
  imports: [
    CommonModule,
    CtModelModule,
    CtButtonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    TranslateModule,
    FlexLayoutModule
  ],
  exports: [ContactPlaceListComponent]
})
export class ContactPlaceListModule {}
